<div class="log-container">
  <h2>Logs ({{ logsPagination.total }})</h2>

  <div class="inline-container">
    <!-- Search Input -->
    <div class="search-container">
      <input nz-input [(ngModel)]="searchEmail" placeholder="Search by user email" (input)="onSearchChange()" />
    </div>

    <div class="table-actions" style="margin-bottom: 10px;">
      <button nz-button nzType="primary" (click)="downloadLogsAsExcel()">
        <span nz-icon nzType="download"></span> Download Logs as Excel
      </button>
    </div>
  </div>

  <!-- Log Table -->
  <nz-table
    [nzData]="logs"
    [nzBordered]="true"
    [nzLoading]="isLoading"
    [nzShowPagination]="false"
  >
    <thead>
    <tr>
      <th nzColumnKey="level" [nzSortOrder]="logsSort.value" (nzSortOrderChange)="onLogsSortChange('level', $event)">
        Level
      </th>
      <th nzColumnKey="logType" [nzSortOrder]="logsSort.value" (nzSortOrderChange)="onLogsSortChange('logType', $event)">
        Type
      </th>
      <th nzColumnKey="message" [nzSortOrder]="logsSort.value" (nzSortOrderChange)="onLogsSortChange('message', $event)">
        Message
      </th>
      <th nzColumnKey="user" [nzSortOrder]="logsSort.value" (nzSortOrderChange)="onLogsSortChange('user', $event)">
        User
      </th>
      <th nzColumnKey="timestamp" [nzSortOrder]="logsSort.value" (nzSortOrderChange)="onLogsSortChange('timestamp', $event)">
        Timestamp
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let log of logs">
      <td>{{ log.level }}</td>
      <td>{{ log.logType }}</td>
      <td>{{ log.message }}</td>
      <td>{{ log.userEmail || 'N/A' }}</td>
      <td>{{ log.timestamp | date: 'short' }}</td>
    </tr>
    </tbody>
  </nz-table>

  <!-- Show a message if no logs are available -->
  <div *ngIf="!isLoading && logs.length === 0" class="empty-state">
    <p>No logs available at the moment.</p>
  </div>

  <!-- Pagination Controls -->
  <nz-pagination
    [nzPageIndex]="logsPagination.pageIndex"
    [nzPageSize]="logsPagination.pageSize"
    [nzTotal]="logsPagination.total"
    [nzPageSizeOptions]="[5, 10, 20, 50]"
    [nzShowQuickJumper]="true"
    [nzShowSizeChanger]="true"
    (nzPageIndexChange)="onLogsPageIndexChange($event)"
    (nzPageSizeChange)="onLogsPageSizeChange($event)"
    style="margin-top: 16px; text-align: right;">
  </nz-pagination>
</div>
